import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.71 41.1899C73.71 41.1899 60.15 34.2999 56.1 29.5699C51.6 24.3099 51.8 1.66992 51.8 1.66992H39.37C39.37 1.66992 39.68 24.4199 35.07 29.5699C30.18 35.0299 17.46 40.9899 17.46 40.9899C23.65 55.5699 36.05 59.2899 45.58 59.2899C55.11 59.2899 67.51 55.7699 73.71 41.1899Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.24 58.0899C85.68 46.0799 82.03 42.8399 77.36 40.4899C75.06 39.3299 60.53 31.6099 60.53 31.6099C60.53 31.6099 55.62 38.5499 45.94 38.5499C36.26 38.5499 30.64 31.6099 30.64 31.6099C30.64 31.6099 16.2 39.2799 13.8 40.4899C9.13 42.8399 5.57 46.4699 3.92 58.0899C2.44 69.1499 2 71.9099 2 71.9099H89.15C89.16 71.8999 88.54 68.3799 87.24 58.0899Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.6904 34.4199C24.6904 34.4199 30.9404 44.6599 44.6704 44.6599C59.8604 44.6599 66.4704 34.4199 66.4704 34.4199"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.5814"
          y1="42.8398"
          x2="45.5814"
          y2="8.80712"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
